import * as actionType from './type'

const INITIAL_STATE = {
    error: "",
    tasks: [],
    pagedTasks: null,
    isUpdatingStatus: false,
    statusUpdateError: null,
    taskStatusBased: [],
    subtasks: [],
    statusConflict: null,
}

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case actionType.RECEIVED_ALL_TASKS: {
            return {
                ...state,
                tasks: action.payload
            }
        }

        case actionType.RECEIVED_ERROR: {
            return {
                ...state,
                error: action.payload
            }
        }

        case actionType.UPDATE_TASK_STATUS_LOADING: {
            return {
                ...state,
                isUpdatingStatus: true,
                statusUpdateError: null,
                statusConflict: null
            }
        }

        case actionType.UPDATE_TASK_STATUS_SUCCESS: {
            return {
                ...state,
                isUpdatingStatus: false,
                statusUpdateError: null,
                statusConflict: null
            }
        }

        case actionType.UPDATE_TASK_STATUS_ERROR: {
            return {
                ...state,
                isUpdatingStatus: false,
                statusUpdateError: action.payload
            }
        }

        case actionType.UPDATE_TASK_STATUS_CONFLICT: {
            return {
                ...state,
                isUpdatingStatus: false,
                statusConflict: action.payload
            }
        }

        case actionType.REQUEST_GET_PAGED_TASKS: {
            return {
                ...state,
                isLoading: true
            }
        }

        case actionType.RECEIVED_PAGED_TASKS: {
            return {
                ...state,
                pagedTasks: action.payload
            }
        }

        case actionType.RECEIVED_TASK_STATUSBASED: {
            return {
                ...state,
                taskStatusBased: action.payload || []
            }
        }

        case actionType.RECEIVED_SUBTASKS: {
            return {
                ...state,
                subtasks: action.payload || []
            }
        }

        default:
            return state;
    }
}
